"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getPlaceOnNetwork = function () {
    return (0, service_1.getService)()
        .get('/managed_campus/networks')
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = getPlaceOnNetwork;
